module.exports = __webpack_public_path__ + "static/img/moreTag.a88e280.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/moreTag.svg
// module id = 5mCi
// module chunks = 0